module.exports = __webpack_public_path__ + "img/fig_dofa_4.3598212b.svg";